import React, { useRef, useCallback, useEffect } from 'react';
import './HighlightedTextarea.css';

function HighlightedTextarea({
  value,
  onChange,
  placeholder,
  disabled,
  rows,
  variables = [],
}) {
  const textareaRef = useRef(null);
  const backdropRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (backdropRef.current && textareaRef.current) {
      backdropRef.current.scrollTop = textareaRef.current.scrollTop;
      backdropRef.current.scrollLeft = textareaRef.current.scrollLeft;
    }
  }, []);

  useEffect(() => {
    handleScroll();
  }, [value, handleScroll]);

  const getHighlightedHtml = useCallback(() => {
    if (!value) return '';

    // Escape HTML entities
    let escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    if (variables.length === 0) return escaped + '\n';

    // Build regex: match {var_name} but not {{var_name}}
    const varNames = variables
      .map((v) => v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|');
    const pattern = new RegExp(
      `(?<!\\{)(\\{(?:${varNames})\\})(?!\\})`,
      'g'
    );

    const highlighted = escaped.replace(
      pattern,
      '<mark class="ht-variable-highlight">$1</mark>'
    );

    return highlighted + '\n';
  }, [value, variables]);

  return (
    <div className="highlighted-textarea-container">
      <div
        ref={backdropRef}
        className="highlighted-textarea-backdrop"
        aria-hidden="true"
      >
        <div
          className="highlighted-textarea-highlights"
          dangerouslySetInnerHTML={{ __html: getHighlightedHtml() }}
        />
      </div>
      <textarea
        ref={textareaRef}
        className="highlighted-textarea-input prompt-textarea"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        onScroll={handleScroll}
      />
    </div>
  );
}

export default HighlightedTextarea;
